import { SecureStorageService } from './../../../Services/secure-storage.service';
import { Component, OnInit } from '@angular/core';
import { localStorageKeys } from '../../../Models/configurations';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  //styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  customerDetail: any;
  dealerDetail: any;
  vehicleDetail: any;
  licensePlateClass:string;

  constructor(
    private readonly secureStorageService: SecureStorageService,
    private globalSetting:GlobalSetting
  ) { }

  public verificationDetails(): void {
    if (typeof (this.secureStorageService.getKeyData(localStorageKeys.checkingModule)) !== 'undefined') {
      this.vehicleDetail = this.secureStorageService.getKeyData(localStorageKeys.checkingModule).vehicleDetail;
      this.customerDetail = this.secureStorageService.getKeyData(localStorageKeys.checkingModule).customerDetail;
      this.dealerDetail = this.secureStorageService.getKeyData(localStorageKeys.checkingModule).dealerDetail;
    }
  }

  ngOnInit(): void {
    this.licensePlateClass=this.globalSetting.getGlobalLicencePlate();
    this.verificationDetails();
    this.refreshDetail();
  }
  private refreshDetail() {
    this.globalSetting.checkinData.subscribe((res) => {
      if (res) {
        this.vehicleDetail = res.vehicleDetail;
        this.customerDetail = res.customerDetail;
        this.dealerDetail = res.dealerDetail;
      }
    })
  }
}
